import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

export const useBackgroundForm = (data) => {
    const {t} = useTranslation();

    const defaultValues = useMemo(() => ({
        firstLanguage: data?.firstLanguage || "",
        nationality: data?.nationality || "",
        countryOfResidence: data?.countryOfResidence || "",
        ethnicities: Array.isArray(data?.ethnicities)
            ? [...data.ethnicities]
            : []
    }), [data]);

    const schema = useMemo(() => yup.object().shape({
        firstLanguage: yup.string().required(t("validation.required")),
        nationality: yup.string().required(t("validation.required")),
        countryOfResidence: yup.string().required(t("validation.required")),
        ethnicities: yup
            .array()
            .of(yup.string())
            .min(1, t("validation.required")),
    }), [t]);

    const {
        control,
        handleSubmit,
        formState: {errors, isValid, isDirty},
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues,
    });

    return {
        handleSubmit,
        control,
        errors,
        isValid,
        isDirty,
    };
};
